
































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {
  FCCategory,
  FCCategoryDef,
  FusionChartTypes,
  FusionThemes,
  WidgetDefinition,
} from '@/components/widgets/WidgetFather'
import ModalPopup from '@/components/dialogs/ModalPopup.vue'
import Button from '@/components/buttons/Button.vue'
import InputString from '@/components/inputs/InputString.vue';
import InputLocation from '@/components/inputs/InputLocation.vue';
import InputEnum from '@/components/inputs/InputEnum.vue';
import InputEnumMap from '@/components/inputs/InputEnumMap.vue';
import InputCascaded from "@/components/inputs/InputCascaded.vue"
import {deepCopy} from '@/utils';
import {hasGlobalOverride} from "@/components/widgets/WidgetMother"

@Component({
  components: {
    ModalPopup,
    Button,
    InputString,
    InputLocation,
    InputEnum,
    InputEnumMap,
    InputCascaded,
  },
})

export default class WidgetSettings extends Vue {
  @Prop({default: null}) public widgetConfig!: WidgetDefinition
  @Prop({default: false}) public global!: boolean
  private originalConfig: any = null
  private config = {} as WidgetDefinition
  public themes = FusionThemes
  private chartTypes: { [key: string]: string } = {}
  public noTheme = [FCCategory.Custom, FCCategory.Gauge]
  public noType = [FCCategory.Custom, FCCategory.Gauge]

  public hasGlobalOverride(pName: string) {
    return hasGlobalOverride(pName)
  }

  public async created() {
    this.originalConfig = deepCopy({}, this.widgetConfig)
    this.config = deepCopy({}, this.widgetConfig)
    this.chartTypes = this.getChartTypes()
  }

  @Watch('config', {deep: true})
  public onConfigChange(val: string) {
    this.$emit('update:widgetConfig', val)
  }

  public save() {
    this.$emit('update:widgetConfig', this.config)
    this.$emit('save')
  }

  public close() {
    this.$emit('update:widgetConfig', this.originalConfig)
    this.$emit('close')
  }

  private getChartTypes(): FCCategoryDef {
    return FusionChartTypes[this.config._cTypes || ""] || {}
  }
}
